import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getSlider = async (userType) => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/slider/${userType}`, {
        headers: { Authorization: token }
    });
};

export const addSlider = async (formData) => {
    const token = await cookie.get("token");
    return await axios.post(`${proxy}/slider/create`, formData, {
        headers: { Authorization: token }
    });
};

export const deleteSlider = async (id) => {
    const token = await cookie.get("token");
    return await axios.delete(`${proxy}/slider/delete/${id}`, {
        headers: { Authorization: token }
    });
};